export const Product = (handle, otpHandle, title, purchaseType) => ({
  product: null,
  otpProduct: null,
  variant: null,
  flavor: "Moroccan Chocolate",
  boosters: [],
  purchaseType: "monthly",
  loading: true,
  subscriptionAlreadyInCart: false,

  get price() {
    return `$${(this.variant?.price || 0) / 100}`.replace(".00", "");
  },

  get smoothiePrice() {
    return `$${(this.variant?.price || 0) / 100 / 25}`;
  },

  async init() {
    const flavor = this.getFlavorFromUrl();
    this.flavor = flavor || (title || "").split(" / ")[0];
    this.boosters = (title || "")
      .split(" / ")
      .slice(1)
      .filter((booster) => booster.toLowerCase() !== "blend");
    if (purchaseType) {
      this.purchaseType = purchaseType;
    }
    this.subscriptionAlreadyInCart = this.purchaseType === "one-time";

    await this.setProduct(handle);
    if (!this.product || !this.otpProduct) {
      return;
    }

    const boosterHandleMap = {
      bis: 8013229392145, //'booster-immune-support',
      bm: 8017966596369, // 'booster-metabolism',
      bhh: 8017966792977, //'booster-heart-health',
      ba: 8017967251729, //'booster-antioxidants',
    };

    const urlParams = new URLSearchParams(window.location.search);
    const _boosters = [];
    urlParams.forEach((value, key) => {
      if (value == "true") {
        const recommendedBoosterId = boosterHandleMap[key];
        const boosterCardInput = document.querySelector(`#booster-${recommendedBoosterId}`);
        if (!boosterCardInput) {
          return;
        }

        _boosters.push(boosterCardInput.value);
      }
    });

    if (_boosters.length) {
      this.boosters = _boosters;
    }

    this.setVariant();

    this.loading = false;

    this.$watch("subscriptionAlreadyInCart", () => {
      if (this.subscriptionAlreadyInCart) {
        const cartChannel = new BroadcastChannel('cart_channel');
        cartChannel.postMessage({
          action: 'subscriptionAlreadyInCart',
          tabId: window.tabId,
        })
      }
    });

    this.$watch("flavor", () => {
      this.setVariant();
    });

    this.$watch("boosters", () => {
      this.setVariant();
    });

    this.$watch("purchaseType", () => {
      this.setVariant();
    });

    document.addEventListener("rebuy:cart.change", this.onCartChange.bind(this));

    const cartChannel = new BroadcastChannel("cart_channel");
    cartChannel.onmessage = (event) => {
      if (!event) {
        return;
      }

      const { data } = event;
      if (!data) {
        return;
      }

      const { action, tabId } = data;
      if (
        [this.subscriptionAlreadyInCart, (action || "") !== "subscriptionAlreadyInCart", !Boolean(tabId), tabId === window.tabId].includes(true)
      ) {
        return;
      }

      this.subscriptionAlreadyInCart = true;
    };
  },

  getFlavorFromUrl() {
    const url = new URL(window.location.href);

    return url.searchParams.get('flavor');
  },

  async setProduct(handle) {
    if (!handle || !otpHandle) {
      return;
    }

    try {
      const [product, otpProduct] = await Promise.all([
        fetch(`/products/${handle}.js`).then((res) => res.json()),
        fetch(`/products/${otpHandle}.js`).then((res) => res.json()),
      ]);

      this.product = product;
      this.otpProduct = otpProduct;
    } catch (error) {
      console.error(error);
    }
  },

  setVariant() {
    const product = this.purchaseType === "monthly" ? this.product : this.otpProduct;

    const { variants } = product;
    if (!variants?.length) {
      return;
    }

    const { flavor, boosters } = this;

    if (!flavor) {
      this.variant = variants[0];
      return;
    }

    const _boosters = boosters.length ? boosters : ["Blend"];

    this.variant = variants.find((item) => {
      return [flavor, ..._boosters].every((option) => item.title.split(" / ").includes(option));
    });

    if (this.variant) {
      return;
    }

    this.variant = this.variant.find((item) => {
      return item.title.includes(flavor);
    });

    if (this.variant) {
      return;
    }

    this.variant = variants[0];
  },

  async handleATC() {
    if (this.loading) {
      return;
    }

    const { variant } = this;
    if (!variant?.available) {
      return;
    }

    const data = {
      items: [
        {
          id: variant.id,
          quantity: 1,
          selling_plan:
            (this.purchaseType === "monthly" && variant.selling_plan_allocations[0]?.selling_plan_id) || null,
        },
      ],
    };

    const { addonVariantIdInput } = this.$refs;
    if (addonVariantIdInput?.checked) {
      const addonVariantId = parseInt(addonVariantIdInput.value || "0");
      if (addonVariantId) {
        data.items.push({
          id: addonVariantId,
          quantity: 1,
        });
      }
    }

    try {
      this.loading = true;

      await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      this.loading = false;
    } catch (error) {
      console.error(error);
    }
  },

  onCartChange() {
    this.updateSubscriptionNotification();
  },

  updateSubscriptionNotification() {
    const items = window.Rebuy?.SmartCart?.items() || [];
    if (!items?.length) {
      this.subscriptionAlreadyInCart = false;
      return;
    }

    this.subscriptionAlreadyInCart = Boolean(items.find((item) => !!item.selling_plan_allocation));
  },

  async goToCheckout() {
    await this.handleATC();
    location.href = '/checkout';
  }
});
